/* eslint-disable */
import libraries from '../arduino/libraries'

export default function init(Blockly, profile) {
  Blockly.Arduino.ifttt = {};

  Blockly.Arduino.ifttt_init_esp01 = function () {
    var a = Blockly.Arduino.quote_(this.getFieldValue("WIFINAME")),
      b = Blockly.Arduino.quote_(this.getFieldValue("WIFIPASS")),
      c = Blockly.Arduino.quote_(this.getFieldValue("WEBHOOKS_KEY"));

    Blockly.Arduino.definitions_.var_wifi_ssid || (
    Blockly.Arduino.definitions_.var_wifi_ssid =
      "const char wifi_ssid[] = " + a + ";"
      );
    Blockly.Arduino.definitions_.var_wifi_pass || (
    Blockly.Arduino.definitions_.var_wifi_pass =
      "const char wifi_pass[] = " + b + ";"
      );
    Blockly.Arduino.definitions_.var_ifttt_host =
      'const char ifttt_host[] = "maker.ifttt.com";';
    Blockly.Arduino.definitions_.var_ifttt_port =
      'const char ifttt_port[] = "80";';
    Blockly.Arduino.definitions_.var_ifttt_webhooks_key =
      "const char ifttt_webhooks_key[] = " + c + ";";
    // Blockly.Arduino.definitions_.var_ifttt_read_api_key =
    //   "const char ifttt_read_api_key[] = " + d + ";";
    Blockly.Arduino.definitions_.definitions_esp01_serial || (
    Blockly.Arduino.definitions_.definitions_esp01_serial =
      "//ESP AT modem over Hardware Serial. You can't use Serial for debugging!!\n" +
      "#define esp8266 Serial "
      );

    Blockly.Arduino.definitions_fnc_["fnc_wifi_connect"] || (
      Blockly.Arduino.definitions_fnc_["fnc_wifi_connect"] =
      'uint8_t espWifiInit() {\n' +
      '  bool err = false;\n' +
      '\n' +
      '  esp8266.begin(115200);                                   // Start at modem\n' +
      '  err |= !sendCommand((char *)"AT", 5, (char *)"OK");      // Kick\n' +
      '  err |= !sendCommand((char *)"AT+RST", 5, (char *)"OK");  // Reset\n' +
      '  delay(4000);\n' +
      '\n' +
      '  err |= !sendCommand((char *)"AT+CWMODE=1", 5, (char *)"OK"); // Station mode\n' +
      '  err |= !sendCommand((char *)"AT+CWJAP=\\""                         +\n' +
      '                       String(wifi_ssid)                            +\n' +
      '                       (char *)"\\",\\""                              +\n' +
      '                       String(wifi_pass)                            +\n' +
      '                       (char *)"\\"", 22, (char *)"OK");        // Connect to WiFi\n' +
      '  err |= !sendCommand((char *)"AT+CIPMUX=0", 5, (char *)"OK"); // Single TCP connection\n' +
      '  return err;\n' +
      '}\n'
    );

    Blockly.Arduino.definitions_fnc_["fnc_send_at_command"] || (
      Blockly.Arduino.definitions_fnc_["fnc_send_at_command"] =
      'bool sendCommand(String command, int maxTry, char readReplay[]) {\n' +
      '  bool found = false;\n' +
      '  uint8_t countTry = 0;\n' +
      '  while (countTry < (maxTry * 1)) {\n' +
      '    esp8266.println(command);\n' +
      '    if (esp8266.find(readReplay)) {\n' +
      '      found = true;\n' +
      '      break;\n' +
      '    }\n' +
      '    countTry++;\n' +
      '  }\n' +
      '  return found;\n' +
      '}\n'
    );

    Blockly.Arduino.setups_.setup_esp_wifi || (
      Blockly.Arduino.setups_.setup_esp_wifi = "  while (espWifiInit());\n"
    );

    return "";
  };

  Blockly.Arduino.ifttt_email = function () {
    var code;
    var nItems = this.itemCount_;
    var elements = Array(this.itemCount_);
    for (var i = 0; i < nItems; i++) {
      elements[i] =
        Blockly.Arduino.valueToCode(
          this,
          "ADD" + i,
          Blockly.Arduino.ORDER_NONE
        ) || "0";
    }
    // list definition
    code = "\nString " + "iftttEmailData" + "[" + nItems + "];";
    Blockly.Arduino.definitions_["var_ld_" + "iftttEmailData"] = code;
    // list length definition
    code = "int " + "iftttEmailData" + "_size = " + nItems + ";";
    Blockly.Arduino.definitions_["var_ld_" + "iftttEmailData" + "_size"] =
      code;

    Blockly.Arduino.definitions_fnc_["fnc_ifttt_email_http_post"] =
      "uint8_t iftttEmailHTTPPost( int numFields ,\n" +
      "                  String iftttEmailData[]) {\n" +
      "  uint8_t err = -1;\n" +
      "  // TCP conection\n" +
      '  if (sendCommand((char *)"AT+CIPSTART=\\"TCP\\",\\"" +\n' +
      '                   String(ifttt_host) + (char *)"\\"," + \n' +
      '                   String(ifttt_port), 15, (char *)"OK")) {\n' +
      "    // Local Strings\n" +
      '    String bodyData    = "";\n' +
      '    String endPoint    = "";\n' +
      '    String headerData  = "";\n' +
      '    String fieldName   = "";\n' +
      '// Payload as JSON\n' +
      '    for (int fieldNumber = 0; fieldNumber < numFields; fieldNumber++) {\n' +
      '      fieldName = "value" + String(fieldNumber+1);\n' +
      '      bodyData += (fieldNumber==0)?"{\\"":",\\"";\n' +
      '      bodyData += fieldName + "\\"" +\n' +
      '                  ":\\"" +\n' +
      '                  iftttEmailData[fieldNumber];\n' +
      '      bodyData += (fieldNumber==numFields-1)?"\\"}":"\\"";\n' +
      '    }\n' +
      '    // Endpoint\n' +
      '    endPoint = String("/trigger/")\n' +
      '             + String("email")\n' +
      '             + String("/with/key/")\n' +
      '             + String(ifttt_webhooks_key);\n' +
      '    // HTTP request\n' +
      '    headerData =  String(F("POST ")) + String(endPoint) + String(F(" HTTP/1.1\\r\\n"))\n' +
      '                + String(F("Host: maker.ifttt.com\\r\\n"))\n' +
      '                + String(F("User-Agent: electrolab/1.0.1\\r\\n"))\n' +
      '                + String(F("Content-Type: application/json;charset=UTF-8\\r\\n"))\n' +
      '                + String(F("Connection: keep-alive\\r\\n"));\n' +
      '    headerData += String(F("Accept: application/json, text/plain, */*\\r\\n"));\n' +
      '    headerData += String(F("Content-Length: ")) + String(bodyData.length()) + String(F("\\r\\n"))\n' +
      '                + String(F("\\r\\n"));\n' +
      '    if (sendCommand((char *)"AT+CIPSEND=" + String(headerData.length()+bodyData.length()), 14, (char *)">")) {\n' +
      '      esp8266.print(headerData);\n' +
      '      esp8266.println(bodyData);\n' +
      '    }\n' +
      '    delay(1500);\n' +
      '    sendCommand((char *)"AT+CIPCLOSE", 10, (char *)"OK");\n' +
      '    err = 0;\n' +
      '  }\n' +
      '  return err;\n' +
      "}\n";
    code = "";
    for (var i = 0; i < nItems; i++) {
      code += "iftttEmailData[" + i + "] = String(" + elements[i] + ");\n";
    }
    code += "iftttEmailHTTPPost(" + nItems + ", iftttEmailData);\n\n";
    // return code
    return code;
  };

  Blockly.Arduino.ifttt_sms = function () {
    var code;
    var nItems = 1;
    var elements = Array(1);
    for (var i = 0; i < nItems; i++) {
      elements[i] =
        Blockly.Arduino.valueToCode(
          this,
          "MESSAGE",
          Blockly.Arduino.ORDER_NONE
        ) || "0";
    }
    // list definition
    code = "\nString " + "iftttSmsData" + "[" + nItems + "];";
    Blockly.Arduino.definitions_["var_ld_" + "iftttSmsData"] = code;
    // list length definition
    code = "int " + "iftttSmsData" + "_size = " + nItems + ";";
    Blockly.Arduino.definitions_["var_ld_" + "iftttSmsData" + "_size"] =
      code;

    Blockly.Arduino.definitions_fnc_["fnc_ifttt_sms_http_post"] =
      "uint8_t iftttSmsHTTPPost( int numFields ,\n" +
      "                  String iftttSmsData[]) {\n" +
      "  uint8_t err = -1;\n" +
      "  // TCP conection\n" +
      '  if (sendCommand((char *)"AT+CIPSTART=\\"TCP\\",\\"" +\n' +
      '                   String(ifttt_host) + (char *)"\\"," + \n' +
      '                   String(ifttt_port), 15, (char *)"OK")) {\n' +
      "    // Local Strings\n" +
      '    String bodyData    = "";\n' +
      '    String endPoint    = "";\n' +
      '    String headerData  = "";\n' +
      '    String fieldName   = "";\n' +
      '// Payload as JSON\n' +
      '    for (int fieldNumber = 0; fieldNumber < numFields; fieldNumber++) {\n' +
      '      fieldName = "value" + String(fieldNumber+1);\n' +
      '      bodyData += (fieldNumber==0)?"{\\"":",\\"";\n' +
      '      bodyData += fieldName + "\\"" +\n' +
      '                  ":\\"" +\n' +
      '                  iftttSmsData[fieldNumber];\n' +
      '      bodyData += (fieldNumber==numFields-1)?"\\"}":"\\"";\n' +
      '    }\n' +
      '    // Endpoint\n' +
      '    endPoint = String("/trigger/")\n' +
      '             + String("sms")\n' +
      '             + String("/with/key/")\n' +
      '             + String(ifttt_webhooks_key);\n' +
      '    // HTTP request\n' +
      '    headerData =  String(F("POST ")) + String(endPoint) + String(F(" HTTP/1.1\\r\\n"))\n' +
      '                + String(F("Host: maker.ifttt.com\\r\\n"))\n' +
      '                + String(F("User-Agent: electrolab/1.0.1\\r\\n"))\n' +
      '                + String(F("Content-Type: application/json;charset=UTF-8\\r\\n"))\n' +
      '                + String(F("Connection: keep-alive\\r\\n"));\n' +
      '    headerData += String(F("Accept: application/json, text/plain, */*\\r\\n"));\n' +
      '    headerData += String(F("Content-Length: ")) + String(bodyData.length()) + String(F("\\r\\n"))\n' +
      '                + String(F("\\r\\n"));\n' +
      '    if (sendCommand((char *)"AT+CIPSEND=" + String(headerData.length()+bodyData.length()), 14, (char *)">")) {\n' +
      '      esp8266.print(headerData);\n' +
      '      esp8266.println(bodyData);\n' +
      '    }\n' +
      '    delay(1500);\n' +
      '    sendCommand((char *)"AT+CIPCLOSE", 10, (char *)"OK");\n' +
      '    err = 0;\n' +
      '  }\n' +
      '  return err;\n' +
      "}\n";
    code = "";
    for (var i = 0; i < nItems; i++) {
      code += "iftttSmsData[" + i + "] = String(" + elements[i] + ");\n";
    }
    code += "iftttSmsHTTPPost(" + nItems + ", iftttSmsData);\n\n";
    // return code
    return code;
  };

  Blockly.Arduino.ifttt_tweet = function () {
    var code;
    var nItems = 1;
    var elements = Array(1);
    for (var i = 0; i < nItems; i++) {
      elements[i] =
        Blockly.Arduino.valueToCode(
          this,
          "MESSAGE",
          Blockly.Arduino.ORDER_NONE
        ) || "0";
    }
    // list definition
    code = "\nString " + "iftttTweetData" + "[" + nItems + "];";
    Blockly.Arduino.definitions_["var_ld_" + "iftttTweetData"] = code;
    // list length definition
    code = "int " + "iftttTweetData" + "_size = " + nItems + ";";
    Blockly.Arduino.definitions_["var_ld_" + "iftttTweetData" + "_size"] =
      code;

    Blockly.Arduino.definitions_fnc_["fnc_ifttt_tweet_http_post"] =
      "uint8_t iftttTweetHTTPPost( int numFields ,\n" +
      "                  String iftttTweetData[]) {\n" +
      "  uint8_t err = -1;\n" +
      "  // TCP conection\n" +
      '  if (sendCommand((char *)"AT+CIPSTART=\\"TCP\\",\\"" +\n' +
      '                   String(ifttt_host) + (char *)"\\"," + \n' +
      '                   String(ifttt_port), 15, (char *)"OK")) {\n' +
      "    // Local Strings\n" +
      '    String bodyData    = "";\n' +
      '    String endPoint    = "";\n' +
      '    String headerData  = "";\n' +
      '    String fieldName   = "";\n' +
      '// Payload as JSON\n' +
      '    for (int fieldNumber = 0; fieldNumber < numFields; fieldNumber++) {\n' +
      '      fieldName = "value" + String(fieldNumber+1);\n' +
      '      bodyData += (fieldNumber==0)?"{\\"":",\\"";\n' +
      '      bodyData += fieldName + "\\"" +\n' +
      '                  ":\\"" +\n' +
      '                  iftttTweetData[fieldNumber];\n' +
      '      bodyData += (fieldNumber==numFields-1)?"\\"}":"\\"";\n' +
      '    }\n' +
      '    // Endpoint\n' +
      '    endPoint = String("/trigger/")\n' +
      '             + String("tweet")\n' +
      '             + String("/with/key/")\n' +
      '             + String(ifttt_webhooks_key);\n' +
      '    // HTTP request\n' +
      '    headerData =  String(F("POST ")) + String(endPoint) + String(F(" HTTP/1.1\\r\\n"))\n' +
      '                + String(F("Host: maker.ifttt.com\\r\\n"))\n' +
      '                + String(F("User-Agent: electrolab/1.0.1\\r\\n"))\n' +
      '                + String(F("Content-Type: application/json;charset=UTF-8\\r\\n"))\n' +
      '                + String(F("Connection: keep-alive\\r\\n"));\n' +
      '    headerData += String(F("Accept: application/json, text/plain, */*\\r\\n"));\n' +
      '    headerData += String(F("Content-Length: ")) + String(bodyData.length()) + String(F("\\r\\n"))\n' +
      '                + String(F("\\r\\n"));\n' +
      '    if (sendCommand((char *)"AT+CIPSEND=" + String(headerData.length()+bodyData.length()), 14, (char *)">")) {\n' +
      '      esp8266.print(headerData);\n' +
      '      esp8266.println(bodyData);\n' +
      '    }\n' +
      '    delay(1500);\n' +
      '    sendCommand((char *)"AT+CIPCLOSE", 10, (char *)"OK");\n' +
      '    err = 0;\n' +
      '  }\n' +
      '  return err;\n' +
      "}\n";
    code = "";
    for (var i = 0; i < nItems; i++) {
      code += "iftttTweetData[" + i + "] = String(" + elements[i] + ");\n";
    }
    code += "iftttTweetHTTPPost(" + nItems + ", iftttTweetData);\n\n";
    // return code
    return code;
  };

  Blockly.Arduino.ifttt_telegram = function () {
    var code;
    var nItems = 1;
    var elements = Array(1);
    for (var i = 0; i < nItems; i++) {
      elements[i] =
        Blockly.Arduino.valueToCode(
          this,
          "MESSAGE",
          Blockly.Arduino.ORDER_NONE
        ) || "0";
    }
    // list definition
    code = "\nString " + "iftttTelegramData" + "[" + nItems + "];";
    Blockly.Arduino.definitions_["var_ld_" + "iftttTelegramData"] = code;
    // list length definition
    code = "int " + "iftttTelegramData" + "_size = " + nItems + ";";
    Blockly.Arduino.definitions_["var_ld_" + "iftttTelegramtData" + "_size"] =
      code;

    Blockly.Arduino.definitions_fnc_["fnc_ifttt_telegram_http_post"] =
      "uint8_t iftttTelegramHTTPPost( int numFields ,\n" +
      "                  String iftttTelegramData[]) {\n" +
      "  uint8_t err = -1;\n" +
      "  // TCP conection\n" +
      '  if (sendCommand((char *)"AT+CIPSTART=\\"TCP\\",\\"" +\n' +
      '                   String(ifttt_host) + (char *)"\\"," + \n' +
      '                   String(ifttt_port), 15, (char *)"OK")) {\n' +
      "    // Local Strings\n" +
      '    String bodyData    = "";\n' +
      '    String endPoint    = "";\n' +
      '    String headerData  = "";\n' +
      '    String fieldName   = "";\n' +
      '// Payload as JSON\n' +
      '    for (int fieldNumber = 0; fieldNumber < numFields; fieldNumber++) {\n' +
      '      fieldName = "value" + String(fieldNumber+1);\n' +
      '      bodyData += (fieldNumber==0)?"{\\"":",\\"";\n' +
      '      bodyData += fieldName + "\\"" +\n' +
      '                  ":\\"" +\n' +
      '                  iftttTelegramData[fieldNumber];\n' +
      '      bodyData += (fieldNumber==numFields-1)?"\\"}":"\\"";\n' +
      '    }\n' +
      '    // Endpoint\n' +
      '    endPoint = String("/trigger/")\n' +
      '             + String("telegram")\n' +
      '             + String("/with/key/")\n' +
      '             + String(ifttt_webhooks_key);\n' +
      '    // HTTP request\n' +
      '    headerData =  String(F("POST ")) + String(endPoint) + String(F(" HTTP/1.1\\r\\n"))\n' +
      '                + String(F("Host: maker.ifttt.com\\r\\n"))\n' +
      '                + String(F("User-Agent: electrolab/1.0.1\\r\\n"))\n' +
      '                + String(F("Content-Type: application/json;charset=UTF-8\\r\\n"))\n' +
      '                + String(F("Connection: keep-alive\\r\\n"));\n' +
      '    headerData += String(F("Accept: application/json, text/plain, */*\\r\\n"));\n' +
      '    headerData += String(F("Content-Length: ")) + String(bodyData.length()) + String(F("\\r\\n"))\n' +
      '                + String(F("\\r\\n"));\n' +
      '    if (sendCommand((char *)"AT+CIPSEND=" + String(headerData.length()+bodyData.length()), 14, (char *)">")) {\n' +
      '      esp8266.print(headerData);\n' +
      '      esp8266.println(bodyData);\n' +
      '    }\n' +
      '    delay(1500);\n' +
      '    sendCommand((char *)"AT+CIPCLOSE", 10, (char *)"OK");\n' +
      '    err = 0;\n' +
      '  }\n' +
      '  return err;\n' +
      "}\n";
    code = "";
    for (var i = 0; i < nItems; i++) {
      code += "iftttTelegramData[" + i + "] = String(" + elements[i] + ");\n";
    }
    code += "iftttTelegramHTTPPost(" + nItems + ", iftttTelegramData);\n\n";
    // return code
    return code;
  };
}